// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "core_corp" + "." + "d9b2b3b5" + ".js";
};